module.exports = __webpack_public_path__ + "img/ro5.4cadd1ce.jpg";